// import React from 'react';
import Loadable from 'react-loadable';
// import Loader from '../../components/BlankLoader/BlankLoader';

const HomeLoadable = Loadable({
    loader: () => import(/* webpackChunkName: 'home' */ 'desktop/containers/Home/Home.js').then(module => module.default),
    loading: () => null
});

export default HomeLoadable;
